<template>
    <div v-if="$store.state.connected" id="userView">
        <User />
    </div>
</template>

<script>
    import User from "@/components/Manager/User.vue";
    import router from "../router/index.js";
    
    export default {
        name: "UserManager",
        data(){
            return{
            }
        },
        components: {
            User,
        },
        created: function() {
            if (!this.$store.state.connected) {
                router.push('connexion');
            } 
        }
    };
</script>

<style scoped>
    #userView{
        height: 100%;
    }
</style>